import {type FunctionalComponent, h} from '@stencil/core';
import type {IDashboardItemHeader} from '../../types/subcomponents-types.type';

export const DashboardItemHeader: FunctionalComponent<IDashboardItemHeader> = (
  props
) => {
    const { labelProvider, title, tabCount, targetTab, subTitle, privateCard, itemCount, term } =
    props;

    const subtitleText = 'Showing {0} of {1} results for {2}';
    const labelText = subTitle
      ? labelProvider('dashboard.tile.description-informative', subtitleText)
      : '';

    const FormatResultString = ()=>{
        try{
          const splitted = labelText.split(/\{|\}/);
          // ['Showing ', '0', ' of ', '1', ' results for ', '2', '']
          const R = ()=>splitted
            .map(s=> s === '0' ? <strong>{itemCount}</strong> : s)
            .map(s=> s === '1' ? <strong>{tabCount}</strong> : s)
            .map(s=> s === '2' ? <strong>{term}</strong> : s)
          ;
          return <span class="FormatResultString"><R /></span>;
        }catch(e){
          return labelText
            .replace('{0}',itemCount.toString())
            .replace('{1}',tabCount.toString())
            .replace('{2}',term.toString());
        }
    };



    return (
      <section class={{ 'item-header': true, private: privateCard }}>
        <p class="item-header__title">
          {title}
          {privateCard ? (
            <span class="item-header__badge">
              <qds-tag
                class="stock-card__badge"
                text={labelProvider('badge.myContent', 'My Content')}
                size="small"
              />
            </span>
          ) : (
            ''
          )}
        </p>
        <p class="item-header__subtitle">
          <div class='item-header__subtitle-results'>
            <FormatResultString />
          </div>
          <uiaas-dashboard-tab-button
            labelProvider={(e, f) => props.labelProvider(e, f)}
            targetTab={targetTab}
            tabCount={tabCount}
            mobileView={props.mobileView}
          />
        </p>
      </section>
    );
};
